export const ROUTE_MAP = {
  home: "/",
  ad: {
    taskList: "/ad-tasks",
    taskDetail: "/ad-tasks/detail",
    taskDetailV2: "/ad-tasks/detail-v2",
  },
  order: {
    payment: "/order-payment",
    paymentResult: "/order-payment-result",
  },
  activity: {
    midyearSale: "/activity/midyear-sale",
    bf2025: {
      gmv: "/activity/bf2025/gmv",
      gmvRules: "/activity/bf2025/gmv/rules",
      ad: "/activity/bf2025/ad",
      adRules: "/activity/bf2025/ad/rules",
    },
  },
  ai: {
    scriptExtract: "/script-extract",
    myScripts: "/my-scripts",
    rewrite: "/rewrite",
    rewriteScript: "/rewrite-script",
    scriptInfo: "/script-info",
  },
  product: {
    list: "/products",
    detail: "",
  },
  doc: {
    tutorial: "/tutorial",
  },
  message: {
    list: "/message",
    detail: "/message/detail",
  },
  bf2025Ai: {
    rules: "/activity/bf2025/ai/rules",
  },
};
